import Axios from './Axios';

const API_URL = '/page-content/';

export const PageContentService = {
    getList: () => Axios.get(API_URL + 'list'),
    add: (values) => Axios.post(API_URL + 'add', values),
    update: (values) => Axios.patch(API_URL + 'update', values),
    delete: (id) => Axios.delete(API_URL + `delete/${id}`)
};
